(function () {
  var whatsappNumber = '8618202402111';
  var actionClass = 'okokcar-card-actions';

  function escapeHtml(value) {
    return String(value).replace(/[&<>'\"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function addStyles() {
    if (document.getElementById('okokcar-whatsapp-card-styles')) return;
    var style = document.createElement('style');
    style.id = 'okokcar-whatsapp-card-styles';
    style.textContent = '\
.okokcar-card-price-note{margin:4px 0 14px;color:#7c8290;font-size:12px;line-height:1.35;text-align:left}\
.okokcar-card-actions{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:8px;margin-top:4px;width:100%}\
.okokcar-card-actions a{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:9px 8px;border:1px solid #1f365f;border-radius:0;font-size:12px;font-weight:700;line-height:1.15;text-align:center;text-decoration:none;transition:transform .2s ease,background-color .2s ease,color .2s ease}\
.okokcar-card-actions a:hover{transform:translateY(-2px)}\
.okokcar-card-actions__inquiry{background:#11b5d3;color:#fff!important;border-color:#11b5d3!important}\
.okokcar-card-actions__inquiry:hover{background:#0b9bb7}\
.okokcar-card-actions__whatsapp{background:#fff;color:#1f365f!important}\
.okokcar-card-actions__whatsapp:hover{background:#f1f5fa}\
.okokcar-card-actions__whatsapp span{margin-right:5px;color:#25d366;font-size:14px}\
@media screen and (max-width:749px){.okokcar-card-actions{grid-template-columns:1fr;gap:6px}.okokcar-card-actions a{min-height:40px;font-size:11px}}';
    document.head.appendChild(style);
  }

  function processCard(card) {
    if (card.querySelector('.' + actionClass)) return;
    var titleLink = card.querySelector('[data-product-title], .card-title');
    var cardInfo = card.querySelector('.card-information__wrapper');
    if (!titleLink || !cardInfo) return;
    var title = titleLink.getAttribute('data-product-title') || titleLink.textContent.trim();
    var productUrl = titleLink.getAttribute('data-product-url') || titleLink.getAttribute('href');
    if (!title || !productUrl) return;
    var absoluteUrl = new URL(productUrl, window.location.origin).href;
    var whatsappText = 'Hello, I would like to know more about ' + title + '. ' + absoluteUrl;
    var actions = document.createElement('div');
    actions.className = actionClass;
    actions.innerHTML = '<a class="okokcar-card-actions__inquiry" href="' + absoluteUrl + '#request-a-quote">Send Inquiry</a>' +
      '<a class="okokcar-card-actions__whatsapp" target="_blank" rel="noopener" href="https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(whatsappText) + '"><span aria-hidden="true">◉</span>WhatsApp</a>';
    cardInfo.appendChild(actions);
  }

  function processCards() {
    document.querySelectorAll('.product-item').forEach(processCard);
  }

  addStyles();
  processCards();
  new MutationObserver(processCards).observe(document.body, { childList: true, subtree: true });
})();